import { Card, DonutPopulated } from '@/components/shared';
import { useService } from '@/hooks';
import { Section } from '@/layout';
import { useFilterContext } from '@/pages/Lgbt/contexts/FilterContext';
import { useHealth } from '@/services/lgbt/health';
import { Data } from 'big-data';
import { useEffect, useMemo } from 'react';
import { resolveColor } from './resolver';

export function Attendance() {
  const { city, orientation, ibge, identity } = useFilterContext();

  const { data, loading, error, request } = useService<Data>();

  useEffect(() => {
    request(() =>
      useHealth.attendance({ ibge, orientation, genderIdentity: identity })
    );
  }, [request, orientation, ibge, identity]);

  const formatedDataDonut = useMemo(() => {
    const total = data.reduce((acc, cur) => acc + cur.value, 0);
    return data.map((d) => {
      const color = resolveColor(d.name);
      const value = Number(((d.value * 100) / total).toFixed(1));

      return {
        ...d,
        color,
        value
      };
    });
  }, [data]);

  return (
    <Section>
      <Card
        title="Acompanhamento e/ou tratamento médico das pessoas LGBTQIA+ entrevistadas no último ano"
        loading={loading}
        error={error}
        empty={data.length === 0}
        tags={[
          city ?? 'Ceará',
          orientation ?? 'Todas as orientações sexuais',
          identity ?? 'Todas as identidades de gênero'
        ]}
      >
        <DonutPopulated
          calculatedOut
          hiddenValue
          labelOnDonut
          donutHeight={300}
          data={formatedDataDonut}
          thickness={40}
          flexDirection="column"
          percentage
        />
      </Card>
    </Section>
  );
}
